export default __webpack_public_path__ + "media/images/elephant_ui_greeting-530b368959aeb035f1ebb16fbc361c71.svg";